import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { App } from './App'
import { installPressFeedback } from '@yoreflix/core/ui/pressFeedback'

/* Touch devices get no hover and no OS tap flash — this is the press affordance. One delegated
   listener; see `@yoreflix/core/ui/pressFeedback` for why it is not `:active`. */
installPressFeedback()

const root = document.getElementById('root')
if (!root) throw new Error('#root missing from index.html')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
